import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';

export const betTrackingAdapter = createEntityAdapter({
    selectId: (entity) => entity.selection_id,
});

const betTracking = createSlice({
    name: 'betTracking',
    initialState: betTrackingAdapter.getInitialState(),
    reducers: {
        setBetTracking: (state, { payload }) => {
            betTrackingAdapter.setAll(state, payload);
        },
        updateBetTracking: (state, { payload }) => {
            betTrackingAdapter.upsertMany(state, payload);
        },
        removeBetTracking: (state, { payload }) => {
            betTrackingAdapter.removeMany(state, payload);
        },
        clearBetTracking: (state) => {
            betTrackingAdapter.removeAll(state);
        },
        removeBetTrackingByEventId: (state, { payload: eventId }) => {
            const idsToRemove = Object.values(state.entities)
                .filter(entity => entity?.event_id === eventId)
                .map(entity => entity.selection_id);

            betTrackingAdapter.removeMany(state, idsToRemove);
        },
    },
});

export const {
    setBetTracking,
    updateBetTracking,
    removeBetTracking,
    clearBetTracking,
    removeBetTrackingByEventId,
} = betTracking.actions;

export default betTracking.reducer;
